export function getRememberedClient(actorId?: string): string | null {
  if (!actorId) return null;
  const key = `ths:remembered-client:${actorId}`;
  try {
    // Keep choices from existing tabs when upgrading from session-only storage.
    return localStorage.getItem(key) ?? sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function rememberClient(actorId: string, clientId: string) {
  try {
    localStorage.setItem(`ths:remembered-client:${actorId}`, clientId);
  } catch {
    // Storage is optional; the current tab can still enter the company.
  }
}
